import TopContents from "../components/TopContents";

export default function Top() {
  return (
    <>
      <TopContents />
    </>
  );
}
